// extracted by mini-css-extract-plugin
export default {"Toolbar":"product_Toolbar__D48XZ","RedLabel":"product_RedLabel__OxDCA"};